var map = {
	"./food1.gif": [
		12042,
		12042
	],
	"./food10.gif": [
		29334,
		29334
	],
	"./food11.gif": [
		49359,
		49359
	],
	"./food12.gif": [
		59912,
		59912
	],
	"./food13.gif": [
		76993,
		76993
	],
	"./food14.gif": [
		93658,
		93658
	],
	"./food15.gif": [
		1059,
		1059
	],
	"./food2.gif": [
		75813,
		75813
	],
	"./food3.gif": [
		26188,
		26188
	],
	"./food4.gif": [
		66815,
		66815
	],
	"./food5.gif": [
		28902,
		28902
	],
	"./food6.gif": [
		47697,
		47697
	],
	"./food7.gif": [
		73080,
		73080
	],
	"./food8.gif": [
		17083,
		17083
	],
	"./food9.gif": [
		57778,
		57778
	],
	"./heart.gif": [
		74627,
		74627
	],
	"./toyOrPlace1.gif": [
		17446,
		17446
	],
	"./toyOrPlace10.gif": [
		50026,
		50026
	],
	"./toyOrPlace11.gif": [
		23795,
		23795
	],
	"./toyOrPlace12.gif": [
		64172,
		64172
	],
	"./toyOrPlace13.gif": [
		47973,
		47973
	],
	"./toyOrPlace14.gif": [
		70438,
		70438
	],
	"./toyOrPlace15.gif": [
		74175,
		74175
	],
	"./toyOrPlace2.gif": [
		36241,
		36241
	],
	"./toyOrPlace3.gif": [
		61624,
		61624
	],
	"./toyOrPlace4.gif": [
		28275,
		28275
	],
	"./toyOrPlace5.gif": [
		586,
		586
	],
	"./toyOrPlace6.gif": [
		64357,
		64357
	],
	"./toyOrPlace7.gif": [
		14732,
		14732
	],
	"./toyOrPlace8.gif": [
		80935,
		80935
	],
	"./toyOrPlace9.gif": [
		6318,
		6318
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16710;
module.exports = webpackAsyncContext;